import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Async Toggle Button",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-async-toggle-button",
    args: {
        error: false,
        on: false,
        syncId: "",
        toggleUrl: "",
        untoggleUrl: "",
    },
    argTypes: {
        error: { control: "boolean" },
        on: { control: "boolean" },
        syncId: { control: "text" },
        toggleUrl: { control: "text" },
        untoggleUrl: { control: "text" },
    },
};

const Template = () =>
    html`<ux-iws-async-toggle-button on
            ><span slot="on">on</span
            ><span slot="off">off</span></ux-iws-async-toggle-button
        >
        <br />
        <ux-iws-async-toggle-button on
            ><span slot="on"><ux-icon name="bookmark" filled></ux-icon> on</span
            ><span slot="off"
                ><ux-icon name="bookmark"></ux-icon> off</span
            ></ux-iws-async-toggle-button
        > `;

const TemplateToggleButtonWithLabel = () => html`
    <ux-iws-async-toggle-button class="ux-button" on>
        <span slot="on"
            ><ux-icon name="bookmark" filled></ux-icon> Favorit</span
        >
        <span slot="off"><ux-icon name="bookmark"></ux-icon> Favorisieren</span>
    </ux-iws-async-toggle-button>
    <ux-iws-async-toggle-button class="ux-button ux-button--no-border">
        <span slot="on"
            ><ux-icon name="bookmark" filled></ux-icon> Favorit</span
        >
        <span slot="off"><ux-icon name="bookmark"></ux-icon> Favorisieren</span>
    </ux-iws-async-toggle-button>
`;

const TemplateSyncedToggleButtons = () => html`
    1:
    <ux-iws-async-toggle-button sync-id="button1" on
        ><ux-icon slot="on" name="bookmark" filled></ux-icon
        ><ux-icon slot="off" name="bookmark"></ux-icon
    ></ux-iws-async-toggle-button>
    2:
    <ux-iws-async-toggle-button sync-id="button2"
        ><ux-icon slot="on" name="bookmark" filled></ux-icon
        ><ux-icon slot="off" name="bookmark"></ux-icon
    ></ux-iws-async-toggle-button>
    <br />
    <br />
    1:
    <ux-iws-async-toggle-button sync-id="button1" on
        ><ux-icon slot="on" name="bookmark" filled></ux-icon
        ><ux-icon slot="off" name="bookmark"></ux-icon
    ></ux-iws-async-toggle-button>
    2:
    <ux-iws-async-toggle-button sync-id="button2"
        ><ux-icon slot="on" name="bookmark" filled></ux-icon
        ><ux-icon slot="off" name="bookmark"></ux-icon
    ></ux-iws-async-toggle-button>
`;

const TemplateToggleButtonsWithApi = () => html`
    <ux-iws-async-toggle-button
        toggle-url="/mock-data/async-toggle-button/async-toggle-button.json"
        ><ux-icon slot="on" name="bookmark" filled></ux-icon
        ><ux-icon slot="off" name="bookmark"></ux-icon
    ></ux-iws-async-toggle-button>
    (working button)
    <br />
    <ux-iws-async-toggle-button toggle-url="/mock-data/404"
        ><ux-icon slot="on" name="bookmark" filled></ux-icon
        ><ux-icon slot="off" name="bookmark"></ux-icon
    ></ux-iws-async-toggle-button>
    (URL returns an error)
`;

export const Default = Template.bind({});

export const WithLabel = TemplateToggleButtonWithLabel.bind({});

export const SyncedToggleButtons = TemplateSyncedToggleButtons.bind({});

export const WithApi = TemplateToggleButtonsWithApi.bind({});
